import { Clock } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription } from "../ui/card";
import FavoriteButton from "../FavoriteButton";

const TYPE_COLORS = {
  visualization: "text-blue-600 bg-blue-50",
  breathing: "text-green-600 bg-green-50",
  focus: "text-purple-600 bg-purple-50",
  confidence: "text-orange-600 bg-orange-50",
  "mental-skill": "text-indigo-600 bg-indigo-50",
  routine: "text-teal-600 bg-teal-50"
};

const DIFFICULTY_STYLES = {
  beginner: "bg-green-100 text-green-800",
  intermediate: "bg-yellow-100 text-yellow-800",
  advanced: "bg-red-100 text-red-800"
};

export function ExerciseCard({ exercise, exerciseNotes, onSelect, onOpenNotes, onFavoriteToggle, exerciseRef }) {
  return (
    <Card
      ref={exerciseRef}
      className="border-0 shadow-lg bg-gradient-to-br from-white to-emerald-50/30 backdrop-blur-sm hover:shadow-2xl hover:scale-105 transition-all duration-300 cursor-pointer group"
      onClick={() => onSelect(exercise)}
    >
      <CardHeader>
        <div className="flex justify-between items-start mb-2">
          <CardTitle className="text-lg text-emerald-900 group-hover:text-emerald-600 transition-colors">
            {exercise.title}
          </CardTitle>
          <div className={`inline-block px-3 py-1 rounded-full text-sm font-medium shadow-sm ${TYPE_COLORS[exercise.type] || "text-gray-600 bg-gray-50"}`}>
            {exercise.type}
          </div>
        </div>
        <CardDescription className="text-sm text-gray-700 mb-3">
          {exercise.description}
        </CardDescription>
        <div className="flex items-center justify-between pt-2 border-t border-emerald-100">
          <div className="flex items-center space-x-2 text-emerald-700">
            <Clock className="w-4 h-4" />
            <span className="text-sm font-medium">{exercise.duration_minutes} min</span>
          </div>
          <div className="flex items-center gap-2">
            {exercise.difficulty && (
              <div className={`px-2 py-1 rounded text-xs font-semibold ${DIFFICULTY_STYLES[exercise.difficulty] || DIFFICULTY_STYLES.beginner}`}>
                {exercise.difficulty}
              </div>
            )}
            <div onClick={(e) => e.stopPropagation()}>
              <button
                onClick={() => onOpenNotes(exercise)}
                className={`p-2 rounded-lg transition-all ${
                  exerciseNotes[exercise.id]
                    ? 'bg-yellow-100 text-yellow-700 hover:bg-yellow-200'
                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                }`}
                title={exerciseNotes[exercise.id] ? "View/Edit Notes" : "Add Notes"}
              >
                <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z" />
                </svg>
              </button>
            </div>
            <div onClick={(e) => e.stopPropagation()}>
              <FavoriteButton
                itemType="exercise"
                itemId={exercise.id}
                itemTitle={exercise.title}
                itemSource="mental_training"
                itemData={{
                  type: exercise.type,
                  duration_minutes: exercise.duration_minutes,
                  difficulty: exercise.difficulty,
                  description: exercise.description
                }}
                size="sm"
                onToggle={onFavoriteToggle}
              />
            </div>
          </div>
        </div>
      </CardHeader>
    </Card>
  );
}
